import { useContext } from "react";
import { Context_UI } from "../../Contexts/Context_UI";
export default function UI_ChipGroup({ id, className, Items }) {
    const UI = useContext(Context_UI);

    return (
        <>
            {Items ?
                <div className={className ? `ChipGroup ${className}` : "ChipGroup"
                } id={id} >
                    {
                        Items.map((Item) => (
                            <div className="Chip" Color={Item.Color}>
                                {Item.Text}
                            </div>
                        ))
                    }
                </div >
                :
                ""
            }

        </>
       
        
    )
}

